import LogoPicker from './LogoPicker';

export default function AllLogosPicker({
  logo,
  setLogo,
  setLogoDimensions,
  darkLogo,
  setDarkLogo,
  setDarkLogoDimensions,
  squareLogo,
  setSquareLogo,
}) {
  return (
    <div>
      <LogoPicker
        logo={logo}
        setLogo={setLogo}
        setLogoDimensions={setLogoDimensions}
        title="Logo"
        label="Setting a logo will replace the blog title in the header. Recommended: 800px x 200px, PNG."
        placeholder={`Drag 'n drop or click to upload an image.`}
      />
      {setDarkLogo && (
        <LogoPicker
          logo={darkLogo}
          setLogo={setDarkLogo}
          setLogoDimensions={setDarkLogoDimensions}
          title="Logo for dark background"
          label="Setting a logo here will replace the logo set above in dark mode on dark backgrounds. Use a light logo to improve visibility. Recommended: 800px x 200px, PNG."
          placeholder={`Drag 'n drop or click to upload an image.`}
        />
      )}
      <LogoPicker
        logo={squareLogo}
        setLogo={setSquareLogo}
        title="Small logo"
        label="The small logo will be shown as the blog's logo on smaller screens and used as favicon.  Recommended: 500px x 500px, PNG."
        placeholder={`Drag 'n drop or click to upload an image.`}
      />
    </div>
  );
}
